// LIBRERIE
import { faStar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const Presentation: React.FC = () => {
    const { t } = useTranslation();

    return (
        <section id="presentation" className="space-ptb">
            <div className="container-fluid w-special">
                <div className="row align-items-center align-items-xl-start">
                    <div className="col-12 col-lg-6 order-lg-2 mb-4 mb-lg-0">
                        <h3>{t('homePage.presentation.subTitle')}</h3>
                        <h2 dangerouslySetInnerHTML={{ __html: t('homePage.presentation.title') as string }}></h2>
                        <p>{t('homePage.presentation.para')}</p>
                        <div className="row">
                            <div className="col-12 col-md-6">
                                <div className="d-flex align-items-center mb-2">
                                    <i><FontAwesomeIcon icon={faStar} className="mr-2" /></i>
                                    <h5 className="m-0">{t('homePage.presentation.element1-title')}</h5>
                                </div>
                                <p>{t('homePage.presentation.element1-para')}</p>
                            </div>
                            <div className="col-12 col-md-6">
                                <div className="d-flex align-items-center mb-2">
                                    <i><FontAwesomeIcon icon={faStar} className="mr-2" /></i>
                                    <h5 className="m-0">{t('homePage.presentation.element2-title')}</h5>
                                </div>
                                <p>{t('homePage.presentation.element2-para')}</p>
                            </div>
                        </div>
                        <Link to={'/chi-siamo'} className="btn btn-primary" title={t('homePage.presentation.btnTitle')as string}>
                            {t('homePage.presentation.btnText')}
                        </Link>
                    </div>
                    <div className="col-12 col-lg-6 order-lg-1">
                        <div className="row">
                            <div className="col-12 col-md-6 mb-3 mb-md-0 pr-md-0">
                                <img src="/assets/images/inHome/p1.webp" alt={t('homePage.presentation.image1Alt') as string} className="img-fluid h-100" />
                            </div>
                            <div className="col-12 col-md-6">
                                <img src="/assets/images/inHome/p3.webp" alt={t('homePage.presentation.image3Alt') as string} className="img-fluid mb-3" />
                                <img src="/assets/images/inHome/p2.webp" alt={t('homePage.presentation.image2Alt') as string} className="img-fluid d-none d-md-block" />
                                
                            </div>
                        </div>
                        <img src="/assets/images/dots.png" alt="dots" className="dots-image"/>
                    </div>
                </div>
            </div>
        </section>
    )
}
export default Presentation;